import * as React from 'react';
import { LoadOptions } from 'app/types-shared';
import { CodeSinglePicker } from 'app/area/codetable/common';
import { ScreenPickerProps, ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';
import { codetableOptionsIds } from 'app/area/codetable/item/screen-renderer/screen-pickers/constants';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { ReadOnlyType } from 'app/area/codetable/item/types';
import { getDisabledValidation } from 'app/area/shared/codetable/item/codetable-item-helpers';
import { manageOptionsButton } from 'app/area/shared/manage-options';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const DefaultUoM = (props: ScreenPickerProps) => {

  const { breadcrumbs, codeItem, updateByKey, resetValidation, codetableOptions, loadCodetableOptions,
    translation, validation, readOnlyConfig } = props;

  const codetableId = codetableOptionsIds.defaultUom;

  const onChange = (value: CodeComplexValue<number>) => {
    resetValidation(ScreenPicker.defaultUom);
    updateByKey(ScreenPicker.defaultUom, value);
  };

  const categoryId = !!codeItem && !!codeItem.defaultUomType &&
    isDefinedIncludingZero(codeItem.defaultUomType.value) ? codeItem.defaultUomType.value : undefined;

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadCodetableOptions(id, codetableId, {
      ...loadOptionsParams, displayNotSelected: false, categoryId
    });
  };

  const codeOptions = (!!codetableOptions[ScreenPicker.defaultUom]
    && codetableOptions[ScreenPicker.defaultUom].codes || []) as CodeComplexValue<number>[];
  const uomValidation = !!validation && !!validation[ScreenPicker.defaultUom] ? validation[ScreenPicker.defaultUom] : undefined;
  const finalValidation = {
    ...uomValidation,
    ...getDisabledValidation(codeItem.defaultUom?.disabled, translation.selected_value_disabled)
  };
  const readOnly = readOnlyConfig && readOnlyConfig[ReadOnlyType.all];

  const extraFooterButton = manageOptionsButton(translation.manage_options, codetableId, breadcrumbs);

  return <CodeSinglePicker
    id={ScreenPicker.defaultUom}
    label={translation.default_uom}
    valueItem={codeItem && codeItem.defaultUom}
    searchRequired={false}
    required={!readOnly}
    readOnly={!categoryId || readOnly}
    options={codeOptions}
    fetchingOptions={codetableOptions[ScreenPicker.defaultUom] && codetableOptions[ScreenPicker.defaultUom].fetching}
    translation={translation}
    onLoadOptions={onLoadOptions}
    onChange={onChange}
    extraFooterButton={extraFooterButton}
    validation={finalValidation}
  />;
};
